'use client';

import { Typography as MuiTypography } from '@mui/material';
import { forwardRef } from 'react';

import { TypographyProps } from './types';

export const Typography = forwardRef<HTMLElement, TypographyProps>(
  (props, ref) => {
    return <MuiTypography ref={ref} color="textPrimary" {...props} />;
  },
);
